export default "__VITE_ASSET__jR5g7mNu__"